import { useEffect, useState } from "react";
import {
  getCachedPayInputConfig,
  requestPayInputConfig,
} from "pages/PayRoll/Configuration/PayInputConfiguration/payInputConfigApi";

// The pay input's settings from Payroll > Configuration > Pay Input
// (enabled, default treatment, approval, allowed sources), so the Pay Inputs
// screen can show only what is configured. Starts from the last loaded copy
// (the sidebar loads it in advance) and refreshes it. `config` is null while
// the first load runs or when it can't be loaded; screens then keep their
// full behaviour.
export const usePayInputConfig = (domain, companyId, payInputType, enabled = true) => {
  const cached = enabled && domain && companyId ? getCachedPayInputConfig(domain, companyId, payInputType) : null;
  const [state, setState] = useState(() => ({ config: cached, loading: Boolean(enabled && domain && companyId && !cached), error: "" }));
  useEffect(() => {
    if (!enabled || !domain || !companyId) {
      setState({ config: null, loading: false, error: "" });
      return undefined;
    }
    const controller = new AbortController();
    const known = getCachedPayInputConfig(domain, companyId, payInputType);
    setState({ config: known, loading: !known, error: "" });
    requestPayInputConfig({ domain, companyId, payInputType, signal: controller.signal })
      .then(({ config }) => { if (!controller.signal.aborted) setState({ config, loading: false, error: "" }); })
      .catch((error) => { if (!controller.signal.aborted) setState((current) => ({ config: current.config, loading: false, error: error.message })); });
    return () => controller.abort();
  }, [domain, companyId, payInputType, enabled]);
  return state;
};

// Is a source (e.g. "MANUAL", "IMPORT") allowed? Without a config, yes.
export const isSourceAllowed = (config, sourceType) => !config || config.sources.includes(sourceType);

// Import has no source of its own unless the server lists one; until then it
// follows Manual Input.
export const isImportAllowed = (config) =>
  !config || (config.sourceOptions.some((option) => option.value === "IMPORT")
    ? config.sources.includes("IMPORT")
    : config.sources.includes("MANUAL"));
